import { isObject } from "lodash-es";
import type { StoreData } from "../controller";

export const storeTypeGuard = (data: StoreData | string): data is StoreData =>
    isObject(data) && data.hasOwnProperty("storeId");
